module.exports = __webpack_public_path__ + "static/media/student-1.b850d1d3.svg";